import React from 'react';
import Svg, {Path, Rect} from 'react-native-svg';

/**
 * SendIconDark — fixed dark-mode variant of SendIcon.
 * Uses a #3A4B61 border rect and #A1B4C3 path strokes.
 * No colour props — colours are baked in for dark mode.
 */
export const SendIconDark = () => (
  <Svg width="36" height="36" viewBox="0 0 36 36" fill="none">
    <Rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      stroke="#3A4B61"
    />
    <Path
      d="M19.6907 24.4577C19.716 24.5208 19.7601 24.5747 19.8169 24.6121C19.8737 24.6494 19.9406 24.6685 20.0086 24.6668C20.0766 24.665 20.1424 24.6425 20.1973 24.6023C20.2521 24.5621 20.2933 24.506 20.3154 24.4417L24.6487 11.775C24.67 11.716 24.6741 11.652 24.6604 11.5907C24.6468 11.5294 24.6159 11.4733 24.5715 11.4289C24.5271 11.3845 24.471 11.3536 24.4097 11.34C24.3484 11.3263 24.2844 11.3304 24.2254 11.3517L11.5587 15.685C11.4944 15.7071 11.4383 15.7483 11.3981 15.8031C11.3578 15.858 11.3353 15.9238 11.3336 15.9918C11.3319 16.0598 11.351 16.1267 11.3883 16.1835C11.4257 16.2403 11.4796 16.2844 11.5427 16.3097L16.8294 18.4297C16.9965 18.4966 17.1483 18.5967 17.2757 18.7238C17.4032 18.851 17.5035 19.0027 17.5707 19.1697L19.6907 24.4577Z"
      stroke="#A1B4C3"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M24.5692 11.4297L17.2759 18.7224"
      stroke="#A1B4C3"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);